import {
  SfSpellingTestAnswerWord,
  SfSpellingTestMode,
} from "@/types/spellingTypes";

export default (
  words: SfSpellingTestAnswerWord[] | null,
  mode: SfSpellingTestMode,
  isPerfect = false,
  activityId: number | null = null,
) => {
  if (!words) {
    return 0;
  }
  if (mode == "practice") {
    const perQ = activityId == 2 ? 2 : 5;
    return words.reduce((res, el) => {
      if (el.attempts.length > 0) {
        return res + perQ;
      }
      return res;
    }, 0);
  }
  const res = words.reduce((res, el) => {
    if (
      el.attempts.length > 0 &&
      el.attempts[el.attempts.length - 1].is_correct
    ) {
      switch (el.attempts.length) {
        case 1:
          return res + 10;
        case 2:
          return res + 8;
        case 3:
          return res + 5;
      }
    }
    return res;
  }, 0);
  return isPerfect ? res + 50 : res;
};
